export default __webpack_public_path__ + "images/211cafdb31595f6a429d721590402cbc.png";